module.exports = __webpack_public_path__ + "static/media/shop.6668785d.svg";